const DAILY_RUN_UTC_HOUR = 11;
const DAILY_INTERVAL_HOURS = 24;
const DAILY_1100_UTC = [DAILY_RUN_UTC_HOUR];
export const agentSchedulePolicies = {
    competitor_watch: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    proof_agent: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    search_demand: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    frontpage_cro: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    abm_prospecting: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    sales_coach: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
    migration_concierge: {
        minimumIntervalHours: DAILY_INTERVAL_HOURS,
        runAtUtcHours: DAILY_1100_UTC,
    },
};
